import HttpClient from '@/services/http-client'

class EnergyDirectionService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/energy-directions/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/energy-directions', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/energy-directions', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/energy-directions/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/energy-directions/' + id)
  }
}

export default () => new EnergyDirectionService()
